var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5045 12C11.6555 12 12.5045 11.151 12.5045 10C12.5045 8.849 11.6555 8 10.5045 8C9.35349 8 8.50449 8.849 8.50449 10C8.50449 11.151 9.35249 12 10.5045 12Z",
    fill: "#0F0E0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7895 4H4.78946C3.68646 4 2.78946 4.841 2.78946 5.875V18.125C2.78946 19.159 3.68646 20 4.78946 20H20.7895C21.8925 20 22.7895 19.159 22.7895 18.125V5.875C22.7895 4.841 21.8925 4 20.7895 4ZM20.7895 18L4.78946 17.989V6L20.7895 6.011V18Z",
    fill: "#0F0E0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7895 9H18.7895V11H14.7895V9ZM15.7895 13H18.7895V15H15.7895V13ZM14.2195 15.536C14.2195 14.162 12.5435 12.75 10.5045 12.75C8.46546 12.75 6.78946 14.162 6.78946 15.536V16H14.2195V15.536Z",
    fill: "#0F0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.b59bbfad822c712afd50a171f52dac67.svg";
export { ForwardRef as ReactComponent };